import React, { useState, useCallback } from 'react';
import ReactDOM from 'react-dom';

export default function PublishPanel({
  id, slug, published, hasPublishRecord, saveStatus,
  publishErrors, setPublishErrors,
  onSaveDraft, onPublish, saving, isPublishing,
  deleteUrl, deleteTitle, deleteConfirm,
  PreviewComponent, previewIdProp,
  translations, compact
}) {
  var t = translations;
  var previewState = useState(false);
  var showPreview = previewState[0];
  var setShowPreview = previewState[1];

  var hasErrors = publishErrors && Object.keys(publishErrors).length > 0;

  var previewProps = {};
  previewProps[previewIdProp] = slug || id;
  previewProps.onClose = function() { setShowPreview(false); };

  var saveLabel = saveStatus === 'saving' ? t.saving : published ? t.save : t.save_draft;

  if (compact) {
    return (
      <div className="publish-panel publish-panel--compact">
        <div className="publish-panel__actions">
          <span className="publish-panel__status-compact">
            <span className={'publish-panel__status-dot publish-panel__status-dot--' + (published ? 'published' : hasPublishRecord ? 'review' : 'draft')} />
            <span className="publish-panel__status-text">{published ? t.published : hasPublishRecord ? t.ready_for_review : t.draft}</span>
          </span>
          {id && (
            <button type="button" className="publish-panel__action-btn" onClick={function() { setShowPreview(true); }} title="Preview">
              <i className="zmdi zmdi-eye" />
            </button>
          )}
          {id && (
            <a href={deleteUrl} className="publish-panel__action-btn publish-panel__action-btn--danger" data-method="delete" data-confirm={deleteConfirm} title={deleteTitle} rel="nofollow">
              <i className="zmdi zmdi-delete" />
            </a>
          )}
          <button type="button" className="publish-panel__action-btn" onClick={onSaveDraft} disabled={saving}>
            <i className="zmdi zmdi-save" />
            {saveLabel}
          </button>
          {!published && (
            <button type="button" className="btn btn-primary btn-sm publish-panel__publish-btn" onClick={onPublish} disabled={saving}>
              <i className="zmdi zmdi-globe zmdi-hc-fw" />
              {isPublishing ? t.publishing : t.publish}
            </button>
          )}
        </div>

        {showPreview && id && ReactDOM.createPortal(
          <PreviewComponent {...previewProps} />,
          document.body
        )}
      </div>
    );
  }

  return (
    <div className="publish-panel">
      <div className="publish-panel__status-block">
        <div className="publish-panel__status">
          <span className={'publish-panel__status-dot publish-panel__status-dot--' + (published ? 'published' : hasPublishRecord ? 'review' : 'draft')} />
          <span className="publish-panel__status-label">{published ? t.published : hasPublishRecord ? t.ready_for_review : t.draft}</span>
        </div>
        <p className="publish-panel__status-hint">
          {published ? t.status_published_hint : hasPublishRecord ? t.status_review_hint : t.status_draft_hint}
        </p>
      </div>

      <div className="publish-panel__actions">
        {id && (
          <button type="button" className="publish-panel__action-btn" onClick={function() { setShowPreview(true); }} title="Preview">
            <i className="zmdi zmdi-eye" />
          </button>
        )}
        {id && (
          <a href={deleteUrl} className="publish-panel__action-btn publish-panel__action-btn--danger" data-method="delete" data-confirm={deleteConfirm} title={deleteTitle} rel="nofollow">
            <i className="zmdi zmdi-delete" />
          </a>
        )}
        <button type="button" className="publish-panel__action-btn" onClick={onSaveDraft} disabled={saving}>
          <i className="zmdi zmdi-save" />
          {saveLabel}
        </button>
        {!published && (
          <button type="button" className="btn btn-primary publish-panel__publish-btn" onClick={onPublish} disabled={saving}>
            {isPublishing ? t.publishing : t.publish}
          </button>
        )}
      </div>

      {hasErrors && (
        <div className="publish-panel__errors">
          {Object.entries(publishErrors).map(function(entry) {
            var field = entry[0];
            var messages = entry[1];
            return messages.map(function(msg, i) {
              return (
                <div key={field + '-' + i} className="publish-panel__error">
                  <i className="zmdi zmdi-alert-circle-o" />
                  {field !== 'base' ? field.replace('_', ' ') + ': ' : ''}{msg}
                </div>
              );
            });
          })}
        </div>
      )}

      {showPreview && id && ReactDOM.createPortal(
        <PreviewComponent {...previewProps} />,
        document.body
      )}
    </div>
  );
}
